export default __webpack_public_path__ + "static/mel-78f521e2ee0d8f96160e1994875e71eb.png";